// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__23DX2","name":"ConsentHeader_name__2Cc7E","birthday":"ConsentHeader_birthday__enyBv","skeleton":"ConsentHeader_skeleton__3j7VH"};